import { render, staticRenderFns } from "./Vasos.vue?vue&type=template&id=785cb936&"
import script from "./Vasos.vue?vue&type=script&lang=js&"
export * from "./Vasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports